
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const OpportunitiesPage = lazy(() => import('../pages/opportunities/page'));
const OpportunityDetailPage = lazy(() => import('../pages/opportunity-detail/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/opportunities',
    element: <OpportunitiesPage />,
  },
  {
    path: '/opportunity/:id',
    element: <OpportunityDetailPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
